import { IUpdateChecklistEntregaAmbienteUseCase } from "../../../presentation/useCases/update/update_checklist_entrega_ambiente_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * UpdateChecklistEntregaAmbienteUseCase
 */

export class UpdateChecklistEntregaAmbienteUseCase implements IUpdateChecklistEntregaAmbienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idChecklistEntregaAmbiente: number,
    descricao?: string,
    ordem?: string,
  ): Promise<void> {
    await this.repository.updateChecklistEntregaAmbiente(
      idChecklistEntregaAmbiente,
      descricao,
      ordem
    );
  }
}
